/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.2 routes of Core::Application.
 * @version f29265dc2b935fd1d678daec1641061affdd083cc7783aecf81bd549a08010cf
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/activity_log(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityLogOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/:id/add_alias(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addAliasOrganizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_alias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authFailurePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /authentications/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticationsEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"authentications"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_items/bulk_assign_request_item(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkAssignRequestItemOrganizationQuoteItemsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_items"],[2,[7,"/"],[2,[6,"bulk_assign_request_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/purchase_selections/bulk_upsert(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpsertOrganizationPurchaseRequestPurchaseSelectionsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"purchase_selections"],[2,[7,"/"],[2,[6,"bulk_upsert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quote_invitations/:id/cancel(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelOrganizationPurchaseRequestQuoteInvitationPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quote_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/clean(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanOrganizationProductsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"clean"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/complete_export_download(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeExportDownloadOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete_export_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/complete_export_status(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeExportStatusOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete_export_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/:id/create_direct_purchase(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDirectPurchaseOrganizationInvoicePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_direct_purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/create_from_pdf(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFromPdfOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"create_from_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/delivery_note_preview(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliveryNotePreviewOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delivery_note_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs(/*path)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPath = /*#__PURE__*/ __jsr.r({"path":{},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[1,[2,[7,"/"],[5,[3,"path"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /identity/email/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_setup/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordSetupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_setup"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationCategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:category_id/subcategories/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} categoryId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationCategorySubcategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"category_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"subcategories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/companies/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationCompanyPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationDeliveryNotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quotes/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_items/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationQuoteItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/request_items/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationRequestItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"request_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSectorPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/:id/edit(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSupplierPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/passwordless/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSessionsPasswordlessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"passwordless"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/approvals/workflows/export(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportOrganizationApprovalsWorkflowsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/export_price_comparison(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportPriceComparisonOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_price_comparison"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/export_purchase_orders(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportPurchaseOrdersOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_purchase_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/export_purchase_selection_json(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportPurchaseSelectionJsonOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_purchase_selection_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/export_request_items(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportRequestItemsOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_request_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /quote_invitations/:token/export_request_items(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportRequestItemsQuoteInvitationPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quote_invitations"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"export_request_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/finalize_quick(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalizeQuickOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize_quick"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /approvals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const globalApprovalsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /identity/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordSetupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/approvals/workflows/import_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importNewOrganizationApprovalsWorkflowsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"import_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/import_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importNewOrganizationProductsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"import_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/import_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importNewOrganizationSectorsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[6,"import_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/import_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importNewOrganizationSuppliersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[6,"import_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/approvals/workflows/import(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importOrganizationApprovalsWorkflowsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members/import(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importOrganizationMembersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/import(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importOrganizationProductsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/import(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importOrganizationSectorsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/import(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importOrganizationSuppliersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members/:id/magic_link(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const magicLinkOrganizationMemberPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_all_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAllAsReadNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_all_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsReadNotificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/:id/mark_as_reviewed(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsReviewedOrganizationDeliveryNotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/:id/mark_as_reviewed(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsReviewedOrganizationInvoicePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/:id/match_items(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matchItemsOrganizationDeliveryNotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"match_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newIdentityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvitationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationCategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:category_id/subcategories/new(.:format)
 * @param {any} organizationSlug
 * @param {any} categoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationCategorySubcategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"subcategories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/companies/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationCompanyPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationDeliveryNotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationInvoicePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationMemberPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quotes/new(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationPurchaseRequestQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quotes/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_items/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationQuoteItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/request_items/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationRequestItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"request_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSectorPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSupplierPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/new_quote_request(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newQuoteRequestOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_quote_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/passwordless/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSessionsPasswordlessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"passwordless"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/challenge/recovery_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTwoFactorAuthenticationChallengeRecoveryCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"recovery_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/challenge/totp/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTwoFactorAuthenticationChallengeTotpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/profile/totp/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTwoFactorAuthenticationProfileTotpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/approvals(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationApprovalsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCategoriesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:category_id/subcategories(.:format)
 * @param {any} organizationSlug
 * @param {any} categoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCategorySubcategoriesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"subcategories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:category_id/subcategories/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} categoryId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCategorySubcategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"category_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"subcategories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/companies(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCompaniesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/companies/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationCompanyPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/daily_activity(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDailyActivityPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"daily_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/dashboard(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDeliveryNotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/:delivery_note_id/comments(.:format)
 * @param {any} organizationSlug
 * @param {any} deliveryNoteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDeliveryNoteCommentsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"delivery_note_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[3,"delivery_note_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_note_items/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDeliveryNoteItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_note_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_note_items(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDeliveryNoteItemsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_note_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationDeliveryNotesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationInvoicePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/:invoice_id/comments(.:format)
 * @param {any} organizationSlug
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationInvoiceCommentsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoice_items/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationInvoiceItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoice_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoice_items(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationInvoiceItemsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoice_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationInvoicesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationMemberPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationMembersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/prices(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPricesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationProductsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/approval_flow(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestApprovalFlowPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"approval_flow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/approvals(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestApprovalsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/comments(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestCommentsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/purchase_selections(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestPurchaseSelectionsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"purchase_selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quotes/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quotes(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestQuotesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quotes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quotes/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_documents/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationQuoteDocumentPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_items/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationQuoteItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quote_items(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationQuoteItemsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quote_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quotes(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationQuotesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quotes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/request_items/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationRequestItemPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"request_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/request_items(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationRequestItemsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"request_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSectorPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/:sector_id/approval_workflow(.:format)
 * @param {any} organizationSlug
 * @param {any} sectorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSectorApprovalWorkflowPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"sector_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[3,"sector_id"],[2,[7,"/"],[2,[6,"approval_workflow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSectorsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/settings/organization(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsOrganizationPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/:id(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSupplierPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSuppliersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/quick_create(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickCreateOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"quick_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/quick_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickNewOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"quick_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/quick_start(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickStartOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"quick_start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /quote_invitations/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quoteInvitationPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quote_invitations"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoNotesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPropertiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoRoutesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/quotes/:id/recalculate(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recalculateOrganizationQuotePath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recalculate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/:id/remove_alias(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAliasOrganizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_alias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/request_complete_export(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestCompleteExportOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_complete_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quote_invitations/:id/resend(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendOrganizationPurchaseRequestQuoteInvitationPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quote_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationCategoriesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:category_id/subcategories/search(.:format)
 * @param {any} organizationSlug
 * @param {any} categoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationCategorySubcategoriesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"subcategories"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/companies/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationCompaniesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/members/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationMembersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationProductsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/sectors/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationSectorsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"sectors"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/search(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOrganizationSuppliersPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:purchase_request_id/quote_invitations/send_invitations(.:format)
 * @param {any} organizationSlug
 * @param {any} purchaseRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendInvitationsOrganizationPurchaseRequestQuoteInvitationsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"purchase_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"purchase_request_id"],[2,[7,"/"],[2,[6,"quote_invitations"],[2,[7,"/"],[2,[6,"send_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sessions/passwordless(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionsPasswordlessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"passwordless"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/appearance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsAppearancePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appearance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/categories/:id/share(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareOrganizationCategoryPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/products/:id/share(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareOrganizationProductPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/suppliers/:id/share(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareOrganizationSupplierPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"suppliers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/simple_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simpleNewOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"simple_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRecedeHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRefreshHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboResumeHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tutorials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tutorialsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/challenge/recovery_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticationChallengeRecoveryCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"recovery_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/challenge/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticationChallengeTotpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/profile/recovery_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticationProfileRecoveryCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"recovery_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authentication/profile/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticationProfileTotpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentication"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/unread(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unreadNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/:id/upload_and_process_quotes(.:format)
 * @param {any} organizationSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAndProcessQuotesOrganizationPurchaseRequestPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_and_process_quotes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/delivery_notes/upload_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadNewOrganizationDeliveryNotesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"delivery_notes"],[2,[7,"/"],[2,[6,"upload_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/invoices/upload_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadNewOrganizationInvoicesPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"upload_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_slug/purchase_requests/upload_new(.:format)
 * @param {any} organizationSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadNewOrganizationPurchaseRequestsPath = /*#__PURE__*/ __jsr.r({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"purchase_requests"],[2,[7,"/"],[2,[6,"upload_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user-manual(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userManualPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user-manual"],[1,[2,[8,"."],[3,"format"]]]]]);

